
function generateUniqueId() {
    return 'id-' + Date.now() + '-' + Math.floor(Math.random() * 1000000);
}

function setCookie(cname, cvalue, exdays) {

    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getUniqueIdCookie() {

    const cookieName = "ttgUniqueId";
    const nameEQ = cookieName + "=";
    const cookies = document.cookie.split(';');

    // Check if the uniqueId cookie exists
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }

    // If the uniqueId cookie doesn't exist, create it
    const uniqueId = generateUniqueId();
    setCookie(cookieName, uniqueId, 365);
    return uniqueId;
}

export { getUniqueIdCookie }